import { useParams } from "react-router-dom";
import  FormUsuario  from "./components/formulario";

export function UsuarioIncluir() {
    const idusuario = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormUsuario idUsuario={idusuario.id} acao="Novo"/>
      </div>
    </>
  );
}
